import { format, parseISO } from "date-fns";
import { ru } from "date-fns/locale";

export const formatDate = (dateString: string): string => {
  const date: Date = parseISO(dateString?.replace(/(\d{2})-(\d{2})-(\d{4})/, '$3-$2-$1'));
  return format(date, 'd MMMM yyyy', { locale: ru });
};
